import type React from 'react';
import { skeletonImage } from './skeletonImage.styles';

const SkeletonImage: React.FC = () => {
  return <div className={skeletonImage} />;
};

export default SkeletonImage;
